import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import gamedayApp from '../../assets/images/gamedayApp.png'
import statsApp from '../../assets/images/statsApp.png'
import streamingApp from '../../assets/images/streamingApp.png'
import MobileApp from './MobileApp'
import MOBILE_APP_STORE_URLS from '../../utils/constants/mobileAppStoreUrls'

const MobileApps = () => {
  const translate = useTranslate();
  const apps = [
    {
      title: 'GameDay',
      androidUrl: MOBILE_APP_STORE_URLS.GAMEDAY.android,
      iosUrl: MOBILE_APP_STORE_URLS.GAMEDAY.ios,
      icon: gamedayApp,
      comment: 'Engage your fans with video, stats, play-by-play and more!'
    },
    {
      title: 'Mismatch Stats',
      androidUrl: MOBILE_APP_STORE_URLS.STATS.android,
      iosUrl: MOBILE_APP_STORE_URLS.STATS.ios,
      icon: statsApp,
      comment: "Modernize your scoresheet, track stats, and get comprehensive reports"
    },
    {
      title: 'Mismatch Streaming',
      androidUrl: MOBILE_APP_STORE_URLS.STREAMING.android,
      iosUrl: MOBILE_APP_STORE_URLS.STREAMING.ios,
      icon: streamingApp,
      comment: "Manage your livestreams directly from your phone"
    },
  ]

  return (
    <div style={{ padding: '24px' }}>
      <Typography variant="h6" style={{ marginBottom: '24px', fontWeight: 500 }}>
        {translate('Mobile Apps')}
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          maxWidth: "100%",
          width: "100%",
          margin: "0 auto",
        }}
      >
        {apps.map(app => <MobileApp key={app.title} app={app} />)}
      </div>
    </div>
  )
}

export default MobileApps